//collection category
// var $ = jQuery;
// if ($(window).width() > 1200 ) {
// jQuery(document).ready(function($) {
//     if ($('.category_list .category_list-box').length > 11) {
//         $('.category_list').slick({
//             dots: true,
//             arrows: false,
//             infinite: false,
//             slidesToScroll: 1,
//             slidesToShow: 11,
//             autoplay: true,
//             // responsive: [{
//             //         breakpoint: 1200,
//             //         settings: {
//             //             slidesToScroll: 1,
//             //             slidesToShow: 8,
//             //             dots: true,
//             //             autoplay: true,
//             //         }
//             //     },
//             //     {
//             //         breakpoint: 991,
//             //         settings: {
//             //             slidesToScroll: 1,
//             //             slidesToShow: 6,
//             //             dots: true,
//             //             autoplay: true,
//             //         }
//             //     },
//             //     {
//             //         breakpoint: 767,
//             //         settings: {
//             //             slidesToScroll: 1,
//             //             slidesToShow: 5,
//             //             dots: true,
//             //             autoplay: true,
//             //         }
//             //     },
//             //     {
//             //         breakpoint: 500,
//             //         settings: {
//             //             slidesToScroll: 2,
//             //             slidesToShow: 4,
//             //             dots: true,
//             //             autoplay: true,
//             //         }
//             //     }
//             // ]
//         });
//     }
// });
// }
// else if ($(window).width() < 1201 ) {
// jQuery(document).ready(function($) {
//     if ($('.category_list .category_list-box').length > 8) {
//         $('.category_list').slick({
//             dots: true,
//             arrows: false,
//             infinite: false,
//             slidesToScroll: 1,
//             slidesToShow: 8,
//             autoplay: true,
            
//         });
//     }
// });

// }

// else if ($(window).width() < 992 ) {
// jQuery(document).ready(function($) {
//     if ($('.category_list .category_list-box').length > 6) {
//         $('.category_list').slick({
//             dots: true,
//             arrows: false,
//             infinite: false,
//             slidesToScroll: 1,
//             slidesToShow: 6,
//             autoplay: true,
//         });
//     }
// });

// }

// else if ($(window).width() < 768 ) {
// jQuery(document).ready(function($) {
//     if ($('.category_list .category_list-box').length > 5) {
//         $('.category_list').slick({
//             dots: true,
//             arrows: false,
//             infinite: false,
//             slidesToScroll: 1,
//             slidesToShow: 5,
//             autoplay: true,
//         });
//     }
// });

// }

// else ($(window).width() < 501 ) {
// jQuery(document).ready(function($) {
//     if ($('.category_list .category_list-box').length > 4) {
//         $('.category_list').slick({
//             dots: true,
//             arrows: false,
//             infinite: false,
//             slidesToScroll: 1,
//             slidesToShow: 4,
//             autoplay: true,
//         });
//     }
// });

// }

var $ = jQuery;
if ($(window).width() > 1200) {
    jQuery(document).ready(function($) {
        if ($('.category_list .category_list-box').length > 11) {
            $('.category_list').slick({
                dots: true,
                arrows: false,
                infinite: false,
                slidesToScroll: 1,
                slidesToShow: 11,
                autoplay: true,
            });
        }
    });
} else if ($(window).width() < 1201 && $(window).width() >= 992) {
    jQuery(document).ready(function($) {
        if ($('.category_list .category_list-box').length > 8) {
            $('.category_list').slick({
                dots: true,
                arrows: false,
                infinite: false,
                slidesToScroll: 1,
                slidesToShow: 8,
                autoplay: true,
            });
        }
    });
} else if ($(window).width() < 992 && $(window).width() >= 768) {
    jQuery(document).ready(function($) {
        if ($('.category_list .category_list-box').length > 6) {
            $('.category_list').slick({
                dots: true,
                arrows: false,
                infinite: false,
                slidesToScroll: 1,
                slidesToShow: 6,
                autoplay: true,
            });
        }
    });
} else if ($(window).width() < 768 && $(window).width() >= 501) {
    jQuery(document).ready(function($) {
        if ($('.category_list .category_list-box').length > 5) {
            $('.category_list').slick({
                dots: true,
                arrows: false,
                infinite: false,
                slidesToScroll: 1,
                slidesToShow: 5,
                autoplay: true,
            });
        }
    });
} else if ($(window).width() < 501) {
    jQuery(document).ready(function($) {
        if ($('.category_list .category_list-box').length > 4) {
            $('.category_list').slick({
                dots: true,
                arrows: false,
                infinite: false,
                slidesToScroll: 1,
                slidesToShow: 4,
                autoplay: true,
            });
        }
    });
}